export const languageElements = {
    items: {
        'multiSelect-allItemsAreSelected': 
        {
            hu: 'Összes elem kiválasztva',
            de: 'Alles ausgewählt',
            en: 'All items are selected.',
        },      

        'multiSelect-clearSearch': 
        {
            hu: 'Keresési feltétel törlése',
            de: 'Suchbedingung löschen',
            en: 'Clear Search',
        },      

        'multiSelect-clearSelected':
        {
            hu: 'Összes kijelölés elvétele',
            de: 'Auswahl löschen',
            en: 'Clear Selected',
        },      

        'multiSelect-noOptions': 
        {
            hu: 'Üres lista',
            de: 'Keine Optionen',
            en: 'No options',
        },      

        'multiSelect-search': 
        {
            hu: 'Keresés',
            de: 'Suche',
            en: 'Search',
        },      

        'multiSelect-selectAll': 
        {
            hu: 'Összes kiválasztása',
            de: 'Alle Optionen auswählen',
            en: 'Select All',
        },      

        'multiSelect-selectAllFiltered': 
        {
            hu: 'Összes kiválasztása',
            de: 'Alle Optionen auswählen (Filter berücksichtigen)',
            en: 'Select All (Filtered)',
        },      

        'multiSelect-selectSomeItems':
        {
            hu: "--- Kérem válasszon! ---",
            de: "--- Bitte wählen! ---",
            en: "--- Please select ---",
        },      

        'multiSelect-create': 
        {
            hu: '#',
            de: '#',
            en: 'Create',
        },      
    }
}
